<template>
    <form autocomplete="off" class="form form-inline" role="form" ref="form">
        <div class="form-group w-100 mb-0">
            <div class="col-xl-2">
                <select
                    class="form-control w-100 custom-select"
                    v-model="currencyID"
                    :disabled="disabled || !currencySelectable || updating"
                    required
                >
                    <option
                        v-for="_currency in currencies"
                        :key="_currency.ID"
                        :value="_currency.ID"
                    >{{ _currency.currency + " (" + _currency.symbol + ")" }}</option>
                </select>
            </div>

            <div class="col-xl-2">
                <input
                    class="form-control w-100"
                    id="costValue"
                    type="number"
                    step="0.01"
                    v-model.number="value"
                    :disabled="disabled || updating"
                    required
                >
            </div>

            <div class="col">
                <select
                    class="form-control w-100 custom-select"
                    v-model="reasonID"
                    :disabled="!reasonSelectable || disabled || updating"
                    required
                >
                    <option
                        v-for="_reason in reasons"
                        :key="_reason.ID"
                        :value="_reason.ID"
                    >{{ __(_reason.reasonEN) }}</option>
                </select>
            </div>

            <div class="float-right ml-2 mr-4" v-if="create">
                <button
                    class="btn btn-success btn-sm"
                    :disabled="disabled || !needsUpdating"
                    @click.prevent="trySubmit"
                >
                    <i class="fas fa-plus"></i>
                </button>
            </div>

            <div class="float-right ml-2 mr-4" v-else>
                <button
                    class="btn btn-success btn-sm ml-1"
                    :disabled="disabled || !needsUpdating || invalidData"
                    @click.prevent="tryUpdate"
                    :title="invalidData ? 'Cost has Invalid data!' : (needsUpdating ? 'Update Cost' : 'Cost does not need updating.')"
                >
                    <i class="fas fa-save"></i>
                </button>

                <button
                    class="btn btn-danger btn-sm"
                    :disabled="disabled || updating"
                    @click.prevent="tryDelete"
                >
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    name: "EnqAdditionalCost",

    props: {
        currencies: {
            required: true,
            type: Array,
        },

        reasons: {
            required: true,
            type: Array,
        },

        index: {
            required: false,
            type: Number,
        },

        initialCurrencyId: {
            required: true,
            type: Number,
        },

        initialValue: {
            required: false,
            type: Number,
        },

        initialReasonId: {
            required: false,
            type: Number,
        },

        disabled: {
            required: true,
            type: Boolean,
        },

        currencySelectable: {
            required: true,
            type: Boolean,
        },

        reasonSelectable: {
            required: true,
            type: Boolean,
        },

        create: {
            required: true,
            type: Boolean,
        },

        onSubmit: {
            required: true,
            type: Function,
        },

        onUpdated: {
            required: true,
            type: Function,
        },

        onDeleted: {
            required: true,
            type: Function,
        },
    },

    data() {
        return {
            currencyID: this.initialCurrencyId,
            value: this.initialValue || 0.0,
            reasonID: this.initialReasonId || this.reasons[0].ID,

            updating: false,
        };
    },

    computed: {
        invalidData() {
            if (
                isNaN(this.value) ||
                !isFinite(this.value) ||
                this.reasonID <= 0 ||
                this.currencyID <= 0 ||
                (this.$refs.form && !this.$refs.form.checkValidity())
            ) {
                return true;
            }

            return false;
        },

        needsUpdating() {
            if (this.create) {
                return !this.updating; // let them create 'blank' ones since they could before
            }

            return (
                !this.updating &&
                (this.currencyID !== this.initialCurrencyId ||
                    this.reasonID !== this.initialReasonId ||
                    this.value !== this.initialValue)
            );
        },
    },

    methods: {
        getParamsForPost() {
            return {
                currencyID: this.currencyID,
                reasonID: this.reasonID,
                value: this.value,
            };
        },

        trySubmit() {
            this.updating = true;
            this.onSubmit(this.index, this.getParamsForPost());
        },

        tryUpdate() {
            this.updating = true;
            this.onUpdated(this.index, this.getParamsForPost());
        },

        tryDelete() {
            this.updating = true;
            this.onDeleted(this.index);
        },

        reset() {
            this.updating = false;
            this.currencyID = this.initialCurrencyId;
            this.reasonID = this.initialReasonId || this.reasons[0].ID;
            this.value = this.initialValue || 0.0;
        },
    },

    watch: {
        initialCurrencyId: function (initialCurrencyId) {
            this.updating = false;
            this.currencyID = initialCurrencyId;
        },

        initialReasonId: function (initialReasonId) {
            this.updating = false;
            this.reasonID = initialReasonId;
        },

        initialValue: function (initialValue) {
            this.updating = false;
            this.value = initialValue;
        },
    },

    mounted() {
        make_input_no_0();
    },
};
</script>

